module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logoPrimary
    }
  })]), _vm._v(" "), _c('v-card-text', [_c('b-card', {
    attrs: {
      "bg-variant": "light"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.fail
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), (!_vm.sent) ? _c('p', {
    staticClass: "center-block"
  }, [_vm._v("Enter your email address and we will send you a link to reset your password.")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.$v.email.$error
    }
  }, [(!_vm.sent) ? _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter your email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$v.email.required && _vm.$v.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your email")]) : _vm._e(), _vm._v(" "), (!_vm.$v.email.validEmail && _vm.$v.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter a valid email")]) : _vm._e()], 1), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "success",
      "show": _vm.sent
    }
  }, [_vm._v("Check your inbox for a password reset email.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.sent) ? _c('v-btn', {
    staticClass: "send-email",
    attrs: {
      "disabled": _vm.$v.$invalid,
      "block": "",
      "color": "secondary",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmailResetPassword('')
      }
    }
  }, [_vm._v("Send password reset email")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c755ca0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 2115
// module chunks = 0